export default __webpack_public_path__ + "static/project-2-9504bf6148ae1e6c0d65830ff831eed6.png";